/**
 * File domain types shared by both apps.
 *
 * Original locations: (identical values, verified):
 *  - web: apps/web/src/types/files.ts (FileErrors)
 *         apps/web/src/store/request/files/types.ts (FileFlags)
 *         apps/web/src/types/files.ts (MergedFileData -> FileMergeMetadata)
 *  - api: apps/api/src/common/interfaces/status.interface.ts (FileErrors)
 *         apps/api/src/common/interfaces/file.interface.ts (FileFlags)
 *         apps/api/src/common/interfaces/fileMergeMetadata.interface.ts (FileMergeMetadata)
 */
/** Reason a file upload/conversion failed. */
export var FileErrors;
(function (FileErrors) {
    FileErrors["AiNonCompatible"] = "AI_NON_COMPATIBLE";
    FileErrors["IncompatibleZipFile"] = "INCOMPATIBLE_ZIP_FILE";
    FileErrors["incompatibleFileType"] = "INCOMPATIBLE_FILE_TYPE";
    FileErrors["uploadError"] = "UPLOAD_ERROR";
})(FileErrors || (FileErrors = {}));
/** Processing flags attached to a stored file. */
export var FileFlags;
(function (FileFlags) {
    FileFlags["ocr"] = "ocr";
})(FileFlags || (FileFlags = {}));
//# sourceMappingURL=file.js.map